// src/platforms/mobile/mobileDetection.ts
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const phone = /Android|iPhone|iPod|Windows Phone|IEMobile|Opera Mini|Mobile/i.test(ua);
  const narrow = window.matchMedia('(max-width: 767px)').matches;
  // iPad no cuenta como teléfono; la app móvil es exclusiva de teléfonos.
  const tablet = /iPad|Tablet/i.test(ua);
  return phone || (narrow && !tablet);
};
